var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[(_vm.show)?_c('div',{staticClass:"action-popover z-20",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }